import React, { useLayoutEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ProductDetailTest from './ProductDetailTest';
import { getListReturnUrl } from './navMemory';
import './ProductDetailPage.css';

const ProductDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const { slug } = useParams<{ slug: string }>();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const handleBack = (e: React.MouseEvent) => {
    e.preventDefault();
    const target = getListReturnUrl();
    navigate(target);
  };

  return (
    <div className="product-detail-page">
      <div className="product-detail-page__bar">
        <a href="/product" className="product-detail-page__back" onClick={handleBack}>
          ← Zpět na seznam střihů
        </a>
      </div>
      <ProductDetailTest />
    </div>
  );
};

export default ProductDetailPage;
